import React from 'react';
import clsx from 'clsx';

import { isNullOrUndefined } from '@utils/utils.tsx';

interface ComponentProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
  fullWidth?: boolean;
  readOnly?: boolean;
  className?: string;
  type?: string;
  dataTestId?: string;
}

const RingilInputText: React.FC<ComponentProps> = ({ value, onChange, disabled, placeholder, fullWidth, className, dataTestId, type = 'text', readOnly = false }) => {
  return (
    <input
      type={type}
      data-testid={dataTestId}
      value={isNullOrUndefined(value) ? '' : value}
      onChange={e => onChange(e.target.value)}
      disabled={disabled}
      placeholder={placeholder}
      className={clsx('h-[2.625rem] p-2 outline-none focus:ring-0 text-base', fullWidth && 'w-full', className)}
      readOnly={readOnly}
      onWheel={event => event.currentTarget.blur()}
    />
  );
};

export default RingilInputText;
